var exports = {
  "oI": "timelineElement__l_1Q03",
  "Ek": "nonLeadingElement__22Zqw7",
  "yq": "nonLeadingElement_inlineAvatars__g_btmU",
};

module.exports = exports;
